import React from 'react';
import { PINK, TEAL, PURPLE } from './primitives';

const BEATS = [
  { label: 'Ignition',   color: PINK,   when: 'posts first',           body: 'One micro-creator seeds the wave.' },
  { label: 'Amplifiers', color: TEAL,   when: 'inside a tight window', body: 'Follow with distinct angles, staggered and jittered.' },
  { label: 'Prompters',  color: PURPLE, when: 'as comments open',      body: 'Stir the conversation — reply, not broadcast.' },
];

const TICKS = [8, 22, 31, 47, 58, 71, 84, 93];

export function FiringOrder() {
  return (
    <div className="rounded-xl p-5 lg:p-6 bg-black/40 border border-white/5" data-testid="firing-order-visual">
      <p className="text-[9px] uppercase tracking-[0.25em] font-black mb-5" style={{ color: PINK }}>Firing order · one burst</p>
      <div className="relative">
        <div className="absolute left-[8%] right-[8%] top-[18px] h-px hidden md:block"
             style={{ background: `linear-gradient(90deg, ${PINK}, ${TEAL} 50%, ${PURPLE})`, opacity: 0.55 }} />
        <div className="absolute left-[30%] right-[30%] top-[10px] h-4 hidden md:block" aria-hidden="true">
          {TICKS.map(t => (
            <span key={t} className="absolute w-px bottom-0" style={{ left: `${t}%`, height: `${6 + (t % 7)}px`, background: TEAL, opacity: 0.7 }} />
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {BEATS.map((b, i) => (
            <div key={b.label} className="flex flex-col items-center text-center" data-testid={`beat-${b.label.toLowerCase()}`}>
              <span className="relative z-10 w-9 h-9 rounded-full flex items-center justify-center text-[11px] font-black tabular-nums"
                    style={{ background: '#0A0A0A', border: `2px solid ${b.color}`, color: b.color, boxShadow: `0 0 18px ${b.color}44` }}>
                {i + 1}
              </span>
              <p className="mt-3 text-sm font-black text-white tracking-tight">{b.label}</p>
              <p className="text-[10px] uppercase tracking-[0.2em] font-bold mt-0.5" style={{ color: b.color }}>{b.when}</p>
              <p className="text-[11.5px] text-gray-400 leading-relaxed mt-1.5 max-w-[220px]">{b.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
